import { orderBy } from 'lodash'

export default {
  getUser(state) {
    return state.user
  },
  getCompanyCountry(state) {
    return state.user.pais
  },
  getUsersRelated(state) {
    return state.usersRelated
  },
  getCheckUserEmployee(state) {
    return state.checkUserEmployee
  },
  getActions(state) {
    const actions = Array.isArray(state.actions) ? state.actions : []
    if (state.payrollStatus) {
      return [...actions, { id: 'payroll', nombre: 'Nómina' }]
    }
    return actions
  },
  getProfile(state) {
    return state.profile
  },
  getConfig(state) {
    return state.config
  },
  getJwt(state) {
    return state.jwt
  },
  getCompanyLoginUrl(state) {
    return state.companyLoginUrl
  },
  getLocale(state) {
    return state.locale
  },
  getIsManagerRole(state) {
    return state.isManagerRole
  },
  getLocaleForDatepicker(state) {
    //@todo el datepicker para otros paises fuera de ES o EN (por ejemplo Brasil) el datepicker no renderiza adecuadamente
    //Esto es por el idioma a manejar por parte del componente, a la hora de llevar una traducción a otros idiomas fuera de ingles o español, se renderiza
    // por defecto en inglés, por parte de frontend se requerirá una POC
    // checar web-empleado/src/locale/index.js

    /*let locale = ''
    forEach(languages, function(item, key) {
      if (item.countries.includes(state.locale)) {
        locale = item.value
        return true
      }
    })
    return locale*/
    return 'ES'
  },
  getTimerSweetAlert(state) {
    return state.timerSweetAlert
  },
  getStateNotOnboarding(state) {
    return state.stateNotOnboarding
  },
  getDocumentsFiltersFolders(state) {
    return state.documentsFiltersFolders
  },
  getDocumentsFiltersDate(state) {
    return state.documentsFiltersDate
  },
  getUserDocumentsTotal(state) {
    return orderBy(state.userDocumentsTotal, ['id'], ['desc'])
  },
  getUserFoldersDocuments(state) {
    return state.userFoldersDocuments
  },
  getUnsignedTotalDocsLength(state) {
    return state.unsignedTotalDocsLength
  },
  getAvatarHeader(state) {
    return state.avatarImage
  },
  getBooleanCameraHandler(state) {
    return state.goBackCameraHandler
  },
  getPrevRoute(state) {
    return state.prevRoute
  },
  isUserActive(state) {
    return state.user.estado_empresa !== 3 ? true : false
  },
  getUserEmail({ user }) {
    const { mail } = user
    return mail
  },
  getPayrollStatus(state) { 
    return state.payrollStatus
  },
  getLinkKeycloakResult(state) {
    return state.linkKeycloakResult
  },
  getManagerTasksPending(state) {
    return state.managerTasksPending
  },
  getIsNativeVersion(state) {
    if (!Array.isArray(state.actions)) return false
    return state.actions.some(a => a.id === '120')
  }
}
